import {
  SET_SCRAPING_RUNS,
} from "./actionTypes";

const INIT_STATE = {
  runHometax: false,
  runCardSales: false,
  runCard: false,
  runCcd: false,
  runPbk: false,
  runCbk: false,
};

const ScrapingRuns = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_SCRAPING_RUNS:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};

export default ScrapingRuns;